import { getTheme } from './registry';

/**
 * Apply a registered theme by ID.
 * Sets a CSS class on <html> for pre-compiled variable overrides
 * and swaps the favicon if the theme provides one.
 */
export function applyTheme(themeId: string): void {
  const root = document.documentElement;
  const targetClass = themeId !== 'default' ? `theme-${themeId}` : null;

  // Skip DOM work if the target class is already the only theme-* class
  const currentThemeClasses = Array.from(root.classList).filter((c) => c.startsWith('theme-'));
  const alreadyApplied =
    (targetClass === null && currentThemeClasses.length === 0) ||
    (currentThemeClasses.length === 1 && currentThemeClasses[0] === targetClass);

  if (!alreadyApplied) {
    for (const cls of currentThemeClasses) {
      root.classList.remove(cls);
    }
    if (targetClass) {
      root.classList.add(targetClass);
    }
  }

  const theme = getTheme(themeId);
  if (theme?.assets.favicon) {
    const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement | null;
    if (link && !link.href.endsWith(theme.assets.favicon)) {
      link.href = theme.assets.favicon;
    }
  }
}
